import { useQuery } from '@tanstack/react-query'

import { fetchAdminSignupDrafts } from '@/api/admin-signup-drafts.api'
import { adminSignupDraftsQueryKeys } from '@/constants/cache-keys.contant'

export const useAdminSignupDraftsListQuery = (options?: { enabled?: boolean }) => {
    return useQuery({
        queryKey: adminSignupDraftsQueryKeys.list(),
        queryFn: fetchAdminSignupDrafts,
        enabled: options?.enabled !== false,
        staleTime: 0,
    })
}
